const challenges = state => state.challenges;
const challengesLoaded = state => state.challengesLoaded;
const archivedChallenges = state => state.archivedChallenges;
const archivedChallengesLoaded = state => state.archivedChallengesLoaded;
const getChallengesByMemberId = state => id => state[`challenges-${id}`] || [];
const member = state => state.member;
const memberCopy = state => state.memberCopy;
const memberLoaded = state => state.memberLoaded;
const getMemberByName = state => name => state[`member-${name}`] || {};
const deleteInProgress = state => state.deleteInProgress;
const memberTeams = state => state.memberTeams;
const memberTeamsLoaded = state => state.memberTeamsLoaded;
const teamsMemberIsAdmin = state => state.teamsMemberIsAdmin;
const teamsMemberIsAdminLoaded = state => state.teamsMemberIsAdminLoaded;
const memberTeamInvites = state => state.memberTeamInvites;
const memberTeamInvitesLoaded = state => state.memberTeamInvitesLoaded;
const getTeamsByMemberId = state => id => state[`teams-${id}`] || [];
const getFriendsByMemberId = state => id => state[`friends-${id}`] || [];
const challengeInvites = state => state.challengeInvites;
const joinRequestMessages = state => state.joinRequestMessages;
const memberFriends = state => state.memberFriends;
const friendsLoaded = state => state.friendsLoaded;
const friendsLoadedByMemberId = state => id => state[`friendsLoaded-${id}`];
const friendsRequesting = state => state.friendsRequesting;
const friendsRequestingLoaded = state => state.friendsRequestingLoaded;
const friendsInvited = state => state.friendsInvited;
const friendsInvitedLoaded = state => state.friendsInvitedLoaded;
const acceptFriendInviteProcessing = state =>
  state.acceptFriendInviteProcessing;
const sendFriendInviteProcessing = state => state.sendFriendInviteProcessing;
const removeFriendProcessing = state => state.removeFriendProcessing;
const stepData = state => state.stepData;
const wellnessChartData = state => state.wellnessChartData;
const wellnessChartDataLoaded = state => state.wellnessChartDataLoaded;
const getStepDataByMemberId = state => id => state[`stepData-${id}`] || [];
const stepDataLoaded = state => state.stepDataLoaded;
const metricDataLoaded = state => state.metricDataLoaded;
const isJournalLastPage = state => state.isJournalLastPage;
const journals = state => state.journals;
const journalEntryStats = state => state.journalEntryStats;
const makeAnEntryJournal = state => state.makeAnEntryJournal;
const journalPageJournal = state => state.journalPageJournal;
const journalPageJournalLoading = state => state.journalPageJournalLoading;
const makeAnEntryJournalLoading = state => state.makeAnEntryJournalLoading;
const getJournalsByMemberId = state => id => state[`journals-${id}`] || [];
const journalsLoaded = state => state.journalsLoaded;
const activities = state => state.activities;
const activitiesLoaded = state => state.activitiesLoaded;
const activitiesLoading = state => state.activitiesLoading;
const milestonesLoaded = state => state.milestonesLoaded;
const messages = state => state.messages;
const messageCount = state => state.messageCount;
const getLeaderboardByMemberId = state => id =>
  state[`leaderboard-${id}`] || {};
const leaderboardLoaded = state => state.leaderboardLoaded;
const getMilestonesById = state => id => state["milestones" + id] || [];
const memberNotice = state => state.memberNotice;
const memberNoticeLoaded = state => state.memberNoticeLoaded;
const pointsLoaded = state => state.pointsLoaded;
const memberOrganizationNotice = state => state.memberOrganizationNotice;
const memberOrganizationNoticeLoaded = state =>
  state.memberOrganizationNoticeLoaded;
const mobileChallenges = state => state.mobileChallenges;
const mobileChallengeLoaded = state => state.mobileChallengeLoaded;

export default {
  challenges,
  challengesLoaded,
  archivedChallenges,
  archivedChallengesLoaded,
  getChallengesByMemberId,
  member,
  memberCopy,
  memberLoaded,
  getMemberByName,
  deleteInProgress,
  memberTeams,
  memberTeamsLoaded,
  memberTeamInvites,
  memberTeamInvitesLoaded,
  getTeamsByMemberId,
  getFriendsByMemberId,
  teamsMemberIsAdmin,
  teamsMemberIsAdminLoaded,
  challengeInvites,
  joinRequestMessages,
  memberFriends,
  friendsLoaded,
  friendsLoadedByMemberId,
  friendsRequesting,
  friendsRequestingLoaded,
  friendsInvited,
  friendsInvitedLoaded,
  acceptFriendInviteProcessing,
  sendFriendInviteProcessing,
  removeFriendProcessing,
  stepData,
  wellnessChartData,
  wellnessChartDataLoaded,
  getStepDataByMemberId,
  stepDataLoaded,
  metricDataLoaded,
  isJournalLastPage,
  journals,
  journalEntryStats,
  makeAnEntryJournal,
  journalPageJournal,
  journalPageJournalLoading,
  makeAnEntryJournalLoading,
  getJournalsByMemberId,
  journalsLoaded,
  activities,
  activitiesLoaded,
  activitiesLoading,
  milestonesLoaded,
  messages,
  messageCount,
  getLeaderboardByMemberId,
  leaderboardLoaded,
  getMilestonesById,
  memberNotice,
  memberNoticeLoaded,
  pointsLoaded,
  memberOrganizationNotice,
  memberOrganizationNoticeLoaded,
  mobileChallenges,
  mobileChallengeLoaded
};
